module.exports = __webpack_public_path__ + "images/nine-year-club-55da0f0ee55d4828f68526a3118b0bed.png";